import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import i18n from "@/plugins/vue-i18n";
export class ExportBillPayment {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportBillpaymentReport(billpaymentReports, startDate, endDate){
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('bill.payment_date'),
        key: 1,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: "Ref1",
        key: 2,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "Ref2",
        key: 3,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.payer'),
        key: 4,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.customer_market_id'),
        key: 5,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.title'),
        key: 6,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.business_name'),
        key: 7,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.space'),
        key: 8,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.amount'),
        key: 9,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.document_id'),
        key: 10,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 11,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.receipt_id'),
        key: 12,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.confirmed_payment_date_at'),
        key: 13,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
    ]

    for(let billpaymentReport of billpaymentReports){
      worksheet.addRow({
        1: billpaymentReport.paymentTimeStamp ? new Date(moment(billpaymentReport.paymentTimeStamp).format("YYYY-MM-DD HH:mm:ss")) : "",
        2: billpaymentReport.ref1,
        3: billpaymentReport.ref2,
        4: billpaymentReport.customerName,
        5: billpaymentReport.customerMarketId,
        6: billpaymentReport.customerData,
        7: billpaymentReport.businessName,
        8: billpaymentReport.areasName,
        9: billpaymentReport.amount,
        10: billpaymentReport.documentId,
        11: billpaymentReport.status,
        12: billpaymentReport.updatedReceiptId,
        13: billpaymentReport.createdAt ? new Date(moment(billpaymentReport.createdAt).format("YYYY-MM-DD HH:mm:ss")) : ""
      })
    }

    return this.saveFile(workbook, `billpayment-${moment(startDate).format("D-M-YYYY")}-to-${moment(endDate).format("D-M-YYYY")}`);
  }

  static async exportBillpaymentReportByProject(billpaymentReports, startDate, endDate){
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('market.market'),
        key: 1,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.payment_date'),
        key: 2,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: "Ref1",
        key: 3,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "Ref2",
        key: 4,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.payer'),
        key: 5,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.customer_market_id'),
        key: 6,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.title'),
        key: 7,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.business_name'),
        key: 8,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.space'),
        key: 9,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.amount'),
        key: 10,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.document_id'),
        key: 11,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 12,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.receipt_id'),
        key: 13,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.confirmed_payment_date_at'),
        key: 14,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
    ]

    for(let billpaymentReport of billpaymentReports){
      worksheet.addRow({
        1: billpaymentReport.marketName,
        2: billpaymentReport.paymentTimeStamp ? new Date(moment(billpaymentReport.paymentTimeStamp).format("YYYY-MM-DD HH:mm:ss")) : "",
        3: billpaymentReport.ref1,
        4: billpaymentReport.ref2,
        5: billpaymentReport.customerName,
        6: billpaymentReport.customerMarketId,
        7: billpaymentReport.customerData,
        8: billpaymentReport.businessName,
        9: billpaymentReport.areasName,
        10: billpaymentReport.amount,
        11: billpaymentReport.documentId,
        12: billpaymentReport.status,
        13: billpaymentReport.updatedReceiptId,
        14: billpaymentReport.createdAt ? new Date(moment(billpaymentReport.createdAt).format("YYYY-MM-DD HH:mm:ss")) : ""
      })
    }

    return this.saveFile(workbook, `billpayment-${moment(startDate).format("D-M-YYYY")}-to-${moment(endDate).format("D-M-YYYY")}`);
  }
}